import * as React from "react";

const StoreContext = React.createContext();
StoreContext.displayName = 'APP STATE'
export default StoreContext;